export default __webpack_public_path__ + "static/media/pencil.b7947a66.svg";